<template>
  <div v-if="experts && experts.length && !loading" class="my-5">
    <h2 class="font-weight-bolder text-primary my-3 h5">{{ $t('Experts.ourExperts') }}</h2>
    <section
      :id="'splide-' + randomId"
      class="splide splide-experts px-0"
      aria-label="experts logo slider"
    >
      <div class="splide__track mask-container">
        <div class="splide__list d-flex align-items-stretch">
          <div
            v-for="expert in experts"
            :key="expert.id"
            class="splide__slide partner-list-single-element-wrapper text-center my-2 d-flex"
          >
            <singleExpertFeature :expert="expert" :settingsPerm="settingsPerm" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  ApolloClient,
  InMemoryCache
} from '@apollo/client/core';
import { provideApolloClient, useQuery } from '@vue/apollo-composable';
import { watch } from 'vue';
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from '../../services/concord_queries.js';
import singleExpertFeature from './singleExpertFeature.vue';

export default {
  name: "expertsFeature",
  props: {
    settingsPerm: Object,
    brandData: Object
  },
  data() {
    return {
      randomId: Math.random().toString(36).substring(2, 15),
      experts: [],
      loading: true,
      splide: null,
      page: 1,
      pageSize: 20,
      sliderPerPage: 4,
      metaCount: 0,
    }
  },
  components: {
    singleExpertFeature
  },
  created() {
    if (this.brandData && this.brandData !== null) {
      this.getBrandExperts();
    }
  },

  methods: {
    getBrandExperts(){
      const cache = new InMemoryCache();
      const customHeaders = {
        platform: "web",
        App: this.settingsPerm.isDevMioActive ? "devmio" : "entwickler"
      };
      const apolloClient = new ApolloClient({
        cache,
        uri: this.settingsPerm.concordBackendURL,
        headers: customHeaders,
      });
      provideApolloClient(apolloClient);
        const { result } = useQuery(CONCORD_QUERIES.GET_BRAND_EXPERTS, {
          brandComplexId: this.brandData,
          page: this.page,
          pageSize: this.pageSize
        },
        {
          fetchPolicy: 'network-only'
        }
      );

      watch(result, (value) => {
        if (
          value &&
          value.getAuthorsByBrandComplex &&
          value.getAuthorsByBrandComplex.Authors &&
          value.getAuthorsByBrandComplex.Authors.length
        ) {
          this.metaCount = value.getAuthorsByBrandComplex.Meta?.count || 0;
          this.experts = [...this.experts, ...value.getAuthorsByBrandComplex.Authors];
          this.loading = false;
          this.$nextTick(() => {
            if (!this.splide) {
              this.mountSplide();
            } else {
              this.splide.refresh();
            }
          });
        }
      });
    },
    mountSplide() {
      let thiz = this;
      let padding = {
        right: "0rem",
        left: "0rem",
      };

      setTimeout(function () {
        if (thiz.experts && thiz.experts.length && thiz.experts.length > 3) {
          padding = {
            right: "0rem",
            left: "0rem",
          };
        }

        if (!thiz.splide) {
          thiz.splide = new Splide(`#splide-${thiz.randomId}`, {
            classes: {
              arrows: 'splide__arrows arrows',
              arrow: 'splide__arrow arrow',
              prev: 'splide__arrow--prev prev',
              next: 'splide__arrow--next next',
            },
            perPage: 4,
            perMove: 1,
            gap: '1rem',
            rewind: false,
            pagination: false,
            padding: padding,
            breakpoints: {
              1600: { perPage: 4 },
              1280: { perPage: 3 },
              991: { perPage: 3 },
              767: { 
                perPage: 2,
              },
              575: {
                perPage: 2,
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
              480: {
                perPage: 1,
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
              320: { 
                perPage: 1, 
                arrows: false, 
                padding: { left: "0rem", right: "3rem" }, 
                start: 0 
              }
            },
          });

          thiz.splide.on("moved", (newIndex) => {
            const lastCardIndex = newIndex + thiz.sliderPerPage;
            if (thiz.experts.length < thiz.metaCount && lastCardIndex >= thiz.experts.length - 1) {
              thiz.page++;
              thiz.getBrandExperts();
            }
          });

          thiz.splide.mount();
        } else {
          thiz.splide.refresh(); // refresh existing instance
        }
      }, 500);
    }
  }
};
</script>

<style scoped>
</style>
